<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(1)"
                        ref="idfunilerpInput"
                        v-model="funil.idFunilErp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :required="isUpdate"
                        :invalid="isUpdate && isNull(funil.idFunilErp)"
                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(2)"
                        ref="descricaoInput"
                        v-model="funil.descricao"
                        :placeholder="'placeholder-preencha'"
                        :maxlength="30"
                        title="descricao"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="isNull(funil.descricao)"
                        :required="true"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(3)"
                        ref="situacaoSelect"
                        title="situacao"
                        :searchable="false"
                        :options="situacoes"
                        v-model="situacao"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="!isUpdate"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FunilService from '@/services/FunilService';
import FunilValidation from '@/services/validations/FunilValidation';
import Message from '@/models/Message';

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CRM_FUNIL'),
            service: new FunilService(this.$http, this.$router),
            validation: new FunilValidation(this.msgs),
            msgs: [],
            isLoading: false,
            isSaving: false,
            permissao: false,
            cantEdit: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            funil: {
                idFunil: null,
                idFunilErp: null,
                descricao: null,
                situacao: null,
                replicapda: null,
            },
            originalIdErp: ''
        };
    },
    watch: {
        funil: {
            deep: true,
            handler: function () {
                if (!this.isLoading) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    created() {
        this.$emit('isChanged', false);

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-funil');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'funil' },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-dados-cadastrais-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;

            this.service
                .find(this.$route.params.id, this.abrev)
                .then(this.mapItems)
                .then((content) => {
                    if (content) {
                        this.funil = content;
                        this.situacao = this.situacoes[this.funil.situacao];
                        this.originalIdErp = this.funil.idFunilErp;
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.$emit('isChanged', false);
                    this.$emit('descricao', this.funil.descricao);
                    this.isLoading = false;
                });
        },
        mapItems({ content }) {
            return {
                idFunil: content.idFunil,
                idFunilErp: content.idFunilErp,
                descricao: content.descricao,
                situacao: content.situacao,
                replicapda: content.replicapda,
            };
        },
        save() {
            this.isLoading = true;

            this.funil.situacao = this.situacao.id;

            let tempfunil = Object.assign({}, this.funil);
            if (this.validation.validate(tempfunil, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.funil.idFunilErp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';

                    this.isLoading = false;
                    
                    return this.$root.showMessage('alert', message, true);
                }

                tempfunil = this.mapTosave(tempfunil);
                this.isSaving = true;
                this.service
                    .save(tempfunil)
                    .then((value) => {
                        if (value.message == null && value.status == 200) {
                            let msg =
                                this.funil.idFunil != null ? 'msg-funil-edita' : 'msg-funil-salva';
                            this.msgs.push(new Message('success', msg, true));

                            this.$emit('isChanged', false);

                            this.funil = value.content;
                            this.$emit('redirect', this.funil.id);
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(e.body.message, { n: tempfunil.idFunilErp }),
                                        true,
                                        false
                                    )
                                );
                            } else if (e.body.message) {
                                this.msgs.push(new Message('alert', e.body.message, true));
                            }
                        } else if (e.body && e.body.status == 409) {
                            this.msgs.push(new Message('alert', e.body.message, true));
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
